import { createFileRoute } from "@tanstack/react-router";
import ResetPassword from "@/pages/ResetPassword";

export const Route = createFileRoute("/reset-password")({
  head: () => ({
    meta: [
      { title: "Reset Password | Statlign" },
      { name: "description", content: "Set a new password for your Statlign account." },
      { property: "og:title", content: "Reset Password | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Set a new password for your Statlign account." },
      { name: "twitter:title", content: "Reset Password | Statlign" },
      { name: "twitter:description", content: "Set a new password for your Statlign account." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ResetPassword,
});
